module.exports = __webpack_public_path__ + "img/icon_logo.3c476260.png";